// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__fGt7U","radioRow":"SimpleQuestionBuilderModal_radioRow__2KLkV"};